import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import * as _ from 'lodash';
import { TextCase } from 'src/app/types/@types/sl-v-types';
import { CastingMode } from '../../att-casting-view.component';
export type BooleanFormat = 'custom' | 'On,Off' | 'Yes,No' | 'Y,N' | 'y,n' | 'True,False' | 'T,F' | 'on,off' | 'yes,no' | 'true,false' | 't,f' | 'ON,OFF' | 'YES,NO' | 'TRUE,FALSE' | '0,1' | '0,-1' | '1,-1';
export type BooleanFormatCase = 'Aa' | 'aa' | 'AA';
export type BooleanLableMode = 'radio-buttons' | 'radio-buttons-h' | 'toggle-switch';
export type CastingBooleanValue = {
	format: BooleanFormat;
	formatCase: BooleanFormatCase;
	labelMode: BooleanLableMode;
	trueValue: string | number;
	falseValue: string | number;
}

@Component({
	selector: 'app-casting-boolean',
	templateUrl: './casting-boolean.component.html',
	styleUrls: ['./casting-boolean.component.scss']
})
export class CastingBooleanComponent implements OnInit {

	public index = -1;

	public onOff = 'On / Off';
	public yesNo = 'Yes / No';
	public yN = 'Y / N';
	public trueFalse = 'True / False';
	public tF = 'T / F';
	public onOffValue: BooleanFormat = 'On,Off';
	public yesNoValue: BooleanFormat = 'Yes,No';
	public yNValue: BooleanFormat = 'Y,N';
	public trueFalseValue: BooleanFormat = 'True,False';
	public tFValue: BooleanFormat = 'T,F';
	public textCase: TextCase;
	public textCaseChange = new EventEmitter<TextCase>();
	public format: BooleanFormat;
	public formatCase: BooleanFormatCase;
	public trueValue: string | number;
	public falseValue: string | number;
	public labelMode: BooleanLableMode = 'toggle-switch';
	private _val: CastingBooleanValue;

	@Input()
	public castingMode:CastingMode = 'entry';

	@Input('value')
	public set value(val: CastingBooleanValue) {
		if (val) {
			this.format = val.format;
			this.formatCase = val.formatCase;
			this.labelMode = val.labelMode;
			this.trueValue = val.trueValue;
			this.falseValue = val.falseValue;
		}

		if (_.isEqual(this._val, val)) {
			this._val = val;
			this.valueChange.emit(this.value);
		}
	}
	public get value(): CastingBooleanValue {
		return {
			format: this.format,
			formatCase: this.formatCase,
			labelMode: this.labelMode,
			trueValue: this.trueValue,
			falseValue: this.falseValue
		}
	}
	@Output()
	public valueChange = new EventEmitter<CastingBooleanValue>();
	constructor() { }

	ngOnInit(): void {
		this.value = this.value;
	}
	SetCase(textCase: 'Aa' | 'aa' | 'AA') {
		const options = {
			onOff: this.format === this.onOffValue,
			yesNo: this.format === this.yesNoValue,
			yN: this.format === this.yNValue,
			trueFalse: this.format === this.trueFalseValue,
			tF: this.format === this.tFValue
		}

		switch (textCase) {
			case 'Aa':
				this.onOff = 'On / Off';
				this.onOffValue = 'On,Off';
				this.yesNo = 'Yes / No';
				this.yesNoValue = 'Yes,No';
				this.yN = 'Y / N';
				this.yNValue = 'Y,N';
				this.trueFalse = 'True / False'
				this.trueFalseValue = 'True,False';
				this.tF = 'T / F';
				this.tFValue = 'T,F';
				break;
			case 'aa':
				this.onOff = 'on / off';
				this.onOffValue = 'on,off';
				this.yesNo = 'yes / no';
				this.yesNoValue = 'yes,no';
				this.yN = 'y / n';
				this.yNValue = 'y,n';
				this.trueFalse = 'true / false'
				this.trueFalseValue = 'true,false';
				this.tF = 't / f';
				this.tFValue = 't,f';
				break;
			case 'AA':
				this.onOff = 'ON / OFF';
				this.onOffValue = 'ON,OFF';
				this.yesNo = 'YES / NO';
				this.yesNoValue = 'YES,NO';
				this.yN = 'Y / N';
				this.yNValue = 'Y,N';
				this.trueFalse = 'TRUE / FALSE'
				this.trueFalseValue = 'TRUE,FALSE';
				this.tF = 'T / F';
				this.tFValue = 'T,F';
				break;
		}
		for (const key in options) {
			if (options.hasOwnProperty(key)) {
				if (options[key] === true) {
					this.format = this[key + 'Value'];
					break;
				}
			}
		}
		this.textCase = textCase;
		// this.textCaseChange.emit(this.textCase);
		this.UpdateValues();
	}
	UpdateLabelMode(mode: BooleanLableMode) {
		this.labelMode = mode;
		this.valueChange.emit(this.value);
	}
	FormatChanged(format: BooleanFormat, index?: number) {
		format = null;
		this.UpdateValues(index);
	}
	UpdateValues(index?: number) {
		if (this.format !== 'custom') {
			if (!this.format) {
				return;
			}
			const [trueValue, falseValue] = this.format.split(',');
			this.trueValue = trueValue;
			this.falseValue = falseValue;
		} else {

		}
		if (!!index) {
			this.index = index;
		}
		this.valueChange.emit(this.value);
	}
	CheckCase(textCase: TextCase) {
		return this.textCase === textCase;
	}


}
